
import { defineComponent } from "vue";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { TableSelectionConfig } from "@/components/controls/catalogueGrid/tableSelectionConfig";
import { TableDesignConfig } from "@/components/controls/catalogueGrid/tableDesignConfig";
import { TextColumnConfig } from "@/components/controls/catalogueGrid/columns/textColumnConfig";
import CatalogueGrid from "@/components/controls/catalogueGrid/CatalogueGrid.vue";
import { DecimalColumnConfig } from "@/components/controls/catalogueGrid/columns/decimalColumnConfig";
import { IntegerColumnConfig } from "@/components/controls/catalogueGrid/columns/integerColumnConfig";
import api from "@/services/api";
import store from "@/store";

export default defineComponent({
  components: {
    CatalogueGrid,
  },
  props: {
    //показатель режима выбора
    selectMode: { required: false, type: Boolean, default: false },
    gridHeight: { required: false, type: String, default: null },
    //функция для получения выбранных элементов
    getSelectedData: { type: Function },
    //функция для вызова при изменении выбранных элементов
    changeSelectedData: { type: Function },
    //модель родительского элемента
    parentModel: { required: true },
    //идет расчет плана
    isCalculation: { required: false },
  },
  methods: {
    onRowPrepared(e: any) {
      if (e.rowType == "header"){
        e.rowElement.bgColor = "#E5F0FF";
      }
    },
    onSelectionChanged(e: any) {
      store.dispatch("loadedPackages/setLoadedPackages", { data: null });
    },
    async getLoadedPackages(){
      let selectedRows = this.$refs.grid.dxGrid.getSelectedRowsData();
      if (selectedRows.length == 0) return;
      const { data } = await api.get("PlanOrderResult/GetLoadedPackages", {
        params: {
          id: selectedRows[0].id,
          idParent: this.parentModel.id,
        },
      });
      const temp = {
        data: data,
      };
      store.dispatch("loadedPackages/setLoadedPackages", temp);
    },
  },
  computed: {},
  data() {
    return {
      toolbarItems: [
        {
          location: "before",
          widget: "dxButton",
          options: {
            text: "Поиск пакетов",
            stylingMode: "outlined",
            onClick: this.getLoadedPackages,
          },
        },
      ],
      // подробности работы custom summary см. на сервере в методе SetCustomSummary
      summaryConfig: {
        totalItems: [
          {
            name: "TotalSummary",
            showInColumn: "number",
            displayFormat: "Итог:",
            summaryType: "custom",
          },
          {
            name: "VolumeSummary",
            showInColumn: "volume",
            column: "volume",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
          },
          {
            name: "VolumeWithoutMarginSummary",
            showInColumn: "volumeWithoutMargin",
            column: "volumeWithoutMargin",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
          },
          {
            name: "LoadeBeforeVolumeSummary",
            showInColumn: "loadedBeforeVolume",
            column: "loadedBeforeVolume",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
          },
          {
            name: "LoadedVolumeSummary",
            showInColumn: "loadedVolume",
            column: "loadedVolume",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
          },
          {
            name: "RemainderSummary",
            showInColumn: "remainder",
            column: "remainder",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
          },
        ],
      },
      editingConfig: new TableEditingConfig({
        allowDeleteAll: false,
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        confirmDelete: true,
        allowDataFill: false,
        allowExport: false,
        allowImport: false,
        allowClearFilter: false,
        allowDeleteMultipleRows: false,
        allowColumnReordering: true,
        enableMasterDetail: true,
        detailComponentName:
          "components/journals/PlanOrderResultJournal/PlanOrderNomenclatureResultJournal.vue",
        mode: "row",
        chooseColumns: false,
      }),
      selectModeEditingConfig: new TableEditingConfig({
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        confirmDelete: false,
        allowDataFill: false,
        allowExport: false,
        allowDeleteMultipleRows: false,
      }),
      columns: [
        new TextColumnConfig({
          dataField: "number",
          caption: "Номер",
        }),
        new TextColumnConfig({
          dataField: "clientName",
          caption: "Заказчик",
        }),
        new TextColumnConfig({
          dataField: "contractName",
          caption: "Договор",
        }),
        new IntegerColumnConfig({
          dataField: "containerCount",
          caption: "Кол-во контейнеров (шт)",
          allowEmpty: true,
        }),
        new DecimalColumnConfig({
          dataField: "volume",
          caption: "Объем (м³)",
          decimalPoints: 1,
        }),
        new DecimalColumnConfig({
          dataField: "volumeWithoutMargin",
          caption: "Объем без мардижин (м³)",
          decimalPoints: 1,
        }),
        new DecimalColumnConfig({
          dataField: "loadedBeforeVolume",
          caption: "Отгружено ранее (м³)",
          decimalPoints: 1,
        }),
        new DecimalColumnConfig({
          dataField: "loadedVolume",
          caption: "Погружено (м³)",
          decimalPoints: 1,
        }),
        new DecimalColumnConfig({
          dataField: "remainder",
          caption: "Остаток (м³)",
          decimalPoints: 1,
        }),
      ],
      designConfig: new TableDesignConfig({
        popUpColumnsCount: 1,
        popUpWidth: "850px",
        horizontalScroll: false,
      }),
      selectionConfig: new TableSelectionConfig({
        mode: "single",
        selectAllMode: "allPages",
        showCheckBoxesMode: "none",
      }),
      pageSizes: [10, 20, 50, 100],
    };
  },
  created() {
    if (this.selectMode) {
      this.editingConfig = this.selectModeEditingConfig;
    }
    if (this.gridHeight) {
      this.designConfig.height = this.gridHeight;
    }
  },
});
